// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"110":"7ffc529f","227":"fab0f1fb","648":"b2d868da","976":"53f01ecf","989":"aabc6469"}[chunkId] + ".chunk.js";
};